import useWebObservability from "hooks/useWebObservability";
import { useEffect } from "react";
import type { WebObservabilityProviderStateProps } from "./WebObservabilityProvider.types";

const WebObservabilityProvider = ({ user }: WebObservabilityProviderStateProps) => {
  const apm = useWebObservability();

  useEffect(() => {
    if (user) {
      apm?.setUserContext({
        email: user.email,
        id: user.id,
      });
      apm?.setContext({
        role: user.role,
      });
    }
  }, [user, apm]);

  return null;
};

export default WebObservabilityProvider;
